import React from 'react';
// @ts-ignore
import LoadingOverlay from 'react-loading-overlay';

interface Props {
    isActive: boolean;
}

const PrometLoader = (props: React.PropsWithChildren<Props>) => {
    return (
        <LoadingOverlay
            active={props.isActive}
            spinner={true}
            className='promet-loader'
        >
            {props.children}
        </LoadingOverlay>
    )
}

export default PrometLoader;
